import actions from './actions';
import mutations from './mutations.js';
import getters from './getters.js';


const state = {
    contractorsData: [],
    contractorsDataPagination: {},
    contractorsDataGETParams: [],
    contractorHistory: {
        selectedOperations: [],
        selectedDocuments: [],
        selected: [],
    },
};

export default {
    namespaced: false,
    state,
    actions,
    mutations,
    getters,
}